import React, { Component, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Layout, Typography, Button,Avatar, Popconfirm, Input, Table, Tag, Badge, Spin, Empty, Drawer, Space, Dropdown, message, Menu, Progress, Modal, Popover, Divider, Card, Tabs, Select } from "antd";
import { PlusOutlined, FilePdfTwoTone,UserOutlined, UploadOutlined, SyncOutlined, CheckCircleFilled, InfoCircleFilled, EllipsisOutlined } from "@ant-design/icons"
import '../styles.css'
import api from "../api";
import { utilities } from "../../../utilities/utlities";
import { useNavigator } from "../../../utilities/navigation";
import { productsConfig } from "../../../configurations/products";
import { useMutation } from "react-query";
const ManageRFI = (props) => {
    const { id,supplierRfi } = useParams();
    const [user] = useState(utilities.loggedUser())
    const [navigator] = useNavigator();
    const [activeFilter, setActiveFilter] = useState('pending')
    const { data, error, isError, isLoading } = api.useRFI(id, user.jwtToken, activeFilter)
    const [selectedRFI, setSelectedRFI] = useState(null)
    const [discarRfi, setDiscardRfi] = useState(false)
    const [ViewRfi, setViewRfi] = useState(false)
    const [rejectionReason, setRejectionReason] = useState([])
    const [missingdata, setMissing] = useState(null)
    const [activity,setActivity]= useState([])
    const [rfi,setRfiData] = useState([])
    const { confirm } = Modal
    const { TextArea } = Input;
    const { Option } = Select;
    const [CurrentRfi, setRefiId] = useState(null)
    const [rfiDetails, setRfiDetail] = useState([])
    const [rfiRejection, setRejection] = useState(true)
    const [selectedRfi, setSelectedRfi] = useState({})

    const mutation = useMutation(data => {
        console.log(data)
        const response = api.acceptRfi({ ...data, reason: rejectionReason, })
        return { ...response, status: data?.status }
    }, {
        onSuccess: (data) => {
            if (data?.status == 'accepted') {
                setMissing(null)
                setViewRfi(false)
            }
            else {
                setRejectionReason([])
                discarRfi(true)
            }
        },
        onError: (err) => {
            setRejectionReason([])

        }
    })
    const senRejection = (value) => {
        setRejectionReason(value)
    }

    useEffect(()=>{
        console.log(data)
        if(user?.type == "distributor"){
             let rfi = data?.rfi?.filter(item=>item?.supplier?.status == activeFilter)
             setRfiData(rfi)
        }else{
            let rfi = data?.rfi?.filter(item=>item?.supplier?.status == activeFilter)
             setRfiData(rfi)
        }
      
    },[data])

    const rejectionReasonOption = [{
        value: "I'm not intrested",
        label: "I am not Intrested",

    },
    {
        value: "Sorry I select SomeOne Else",
        label: "Sorry I select SomeOne Else",

    },
    {
        value: "Product is not Needed Yet",
        label: "Product is not Needed Yet",

    }
    ]
    function showConfirm() {
        confirm({
            title: <span><Text type="danger">*</Text>Please provide the reason of Rejection</span>,
            content: <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Select Rejection Reason"
                defaultValue={rejectionReason}
                onChange={(e) => {
                    console.log(e)
                    setRejectionReason(e)
                }}
                optionLabelProp="label"
            >

                {rejectionReasonOption?.map(item => {
                    return <Option value={item?.value} label={item?.label}>
                        <div className="demo-option-label-item">
                            {item?.label}
                        </div>
                    </Option>
                })

                }
            </Select>,
            okText: 'Reject',
            id: "RejectionModal",
            okType: 'danger',
            className: 'rejectionDialog',
            onOk() {
                console.log(rejectionReason)
                mutation.mutateAsync({
                    rfiId: CurrentRfi,
                    token: user?.jwtToken,
                    status: 'rejected'


                })
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    var columns = [{
        title: 'ID',
        dataIndex: '_id',
        render: item => {
            return (
                <Text>{item.slice(item.length - 7, item.length)}</Text>
            )
        }
    }, {
        title: 'Supplier',
        dataIndex: 'supplier',
        render: item => {
            return (
                <Text>{item.name}</Text>
            )
        }
    }, {
        title: 'Product',
        dataIndex: 'productRequired',
        render: item => {
            return (
                <Text>{item.name + " " + item.strength}</Text>
            )
        }
    }, {
        title: 'Created at',
        dataIndex: 'createdAt',
        render: item => {
            let date = new Date(item)
            return (
                <Text>{date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()}</Text>
            )
        }
    }, {

        title: 'Closing date',
        dataIndex: 'closingDate',
        render: item => {
            return data ? (
                <Text>{data?.rfq?.closingDate}</Text>
            ) : null
        }
    }, {
        title: 'Actions',

        render: (item, obj) => {
            if (data?.rfq != undefined) {
                return (
                    <Popover content={popoverContent} trigger="click" placement="bottom">
                        <Text onClick={() => setSelectedRFI(obj._id)} style={{ fontSize: 30, color: '#1890ff', cursor: 'pointer' }}>...</Text>
                    </Popover>
                )
            }
            else {
                return (
                    <Space>
                        <Button onClick={() => {
                            setRefiId(obj?._id)
                            setViewRfi(true)
                            const currentRfi = data?.rfi?.filter(item => item?._id == obj?._id)[0]
                            setRfiDetail(Object.keys(currentRfi?.productDetails))
                            setSelectedRfi(obj)
                        }}>View RFI</Button>
                        {obj?.activity?.length > 0 ? <Button onClick={() => {
                            // setViewData(true)
                            // setRefiId(obj?._id)
                            // setViewRfi(true)
                            navigator(`/supplier/${obj._id}`)
                            const currentRfi = data?.rfi?.filter(item => item?._id == obj?._id)[0]
                            setActivity(currentRfi?.activity)
                            setRfiDetail(Object.keys(currentRfi?.productDetails))
                            setSelectedRfi(obj)
                        }}>View Activity</Button>:null}
                    </Space>
                )

            }

        }
    }
    ]
    if (data?.rfq != undefined) {
        columns = columns
    }
    else {
        const filterColum = columns?.filter(item => item?.dataIndex != 'closingDate')
        columns = filterColum
    }
    useEffect(() => {
        let filter = 'pending'
        let filterParam = utilities.getParameterByName('filter')
        if (filterParam) {
            filter = filterParam
        }
        setActiveFilter(filter)
    }, [])
    const onTabChanged = (key) => {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filter=' + key;
        window.history.pushState({ path: newurl }, '', newurl);
        setActiveFilter(key)
    }
    const popoverContent = (
        <Space direction='vertical'>
            <Link style={{ color: 'rgba(0,0,0,0.85', marginBottom: 10 }} to={`/rfi/${id}/${selectedRFI}`}>
                View
            </Link>
            {user?.type == "supplier" ? null : <Link style={{ color: 'rgba(0,0,0,0.85', marginBottom: 10 }} to={`/manage-rfi/${selectedRFI}`} onClick={(e) => {
                e.preventDefault()
                DiscardRfi(true)

            }}>
                Discard
            </Link>}
        </Space>
    );

    const DiscardRfi = (value) => {
        setDiscardRfi(value)
    }

    const onAddMissingValue = (key, value) => {
        setMissing({
            ...missingdata,
            [key]: value
        })
    }
    const { Content } = Layout;
    const { Text, Link: Linking } = Typography
    const { TabPane } = Tabs;
    return (

        <Layout className="layout">
            <Drawer
                title={`View RFI`}
                placement="right"
                width={600}
                onClose={() => { setViewRfi(false) }}
                visible={ViewRfi}
                extra={
                    rfiRejection == true ? null :
                        <Space>
                            <Button onClick={() => { }}>Cancel</Button>
                            <Button type="primary"
                                loading={mutation.isLoading}
                                className="reg-btn" onClick={() => {
                                    mutation.mutateAsync({
                                        rfiId: CurrentRfi,
                                        token: user?.jwtToken,
                                        status: 'accepted',
                                        productDetails: missingdata


                                    })
                                }}>
                                Send Response
                            </Button>
                        </Space>
                }
            >
                <div className="confirmation-part">
                    {selectedRfi?.supplier?.status == 'rejected' ?
                        <span>You have <Linking href="https://ant.design" target="_blank" >Rejected</Linking> this RFI!</span> :
                        rfiRejection == true ?
                            <Text>Want to participate in this RFI ? <i>"Accept" it</i>,if not then <i>"Reject"</i> it</Text> :
                            <span>You have <Linking href="https://ant.design" target="_blank" >Accepted</Linking> this RFI!</span>

                    }
                    {
                        selectedRfi?.supplier?.status == 'rejected' ?
                            null :
                            rfiRejection == true ?
                                <Space>
                                    <Button type="primary" onClick={() => {
                                        setRejection(false)
                                    }}>Accept</Button>
                                    <Button type="danger" onClick={() => {
                                        showConfirm()
                                    }}>Reject</Button>
                                </Space> : null
                    }

                </div>
                <div className="missingFields">
                    <Text>Please add following information and send Response</Text>
                    {
                        productsConfig?.fields?.map(item => {
                            if (!rfiDetails?.includes(item?.name)) {
                                return <div className="missigData">
                                    <Text>{item?.title}</Text>
                                    <Input disabled={rfiRejection} onChange={(e) => {
                                        onAddMissingValue(item?.name, e.target.value)
                                    }}></Input>
                                </div>
                            }
                        })

                    }
                </div>
            </Drawer>
            <Modal title={<><InfoCircleFilled className="infoInformation"></InfoCircleFilled> Discard</>} visible={discarRfi} onOk={() => { }} onCancel={() => { }}
                footer={[
                    <Button key="back" onClick={() => {
                        DiscardRfi(false)
                    }}>
                        Cancel
                    </Button>,
                    <Button
                        loading={mutation.isLoading}
                        key="submit" type="primary" className="discardRfi" onClick={() => {
                        }}>
                        Discard
                    </Button>]}
            >
                <p>Do you Really want to discard RFI ? </p>
            </Modal>

            <Content style={{ justifyContent: 'flex-start', marginTop: 25 }} className="site-layout-content">
                {
                    supplierRfi == null ?
                        isLoading ? <Spin></Spin> :
                            <div style={{ width: '100%' }}>
                                <div style={{ width: '80%', 
                                padding: '0 26px 10px' }}>
                                    <Text style={{ fontWeight: 500, fontSize: 18 }}>Manage RFI</Text>
                                    {user?.type == "supplier" ? null : <div style={{ width: '40%', justifyContent: 'flex-start', fontSize: 12 }}>
                                        <Link to="/rfq" className="link">Manage RFQ</Link>
                                        <Text type="secondary"> / {data?.rfq?.title}</Text>
                                    </div>}

                                </div>
                                <Card style={{ width: '100%' }}>
                                    <div 
                                    // style={{ padding: '0 80px 10px' }}
                                    >
                                        <Space style={{ width: '100%' }} direction='vertical' size={8}>
                                            <Tabs activeKey={activeFilter} defaultActiveKey='pending' className="ManageRfi" onChange={onTabChanged}>
                                                <TabPane tab="Pending" key="pending"></TabPane>
                                                <TabPane tab="Accepted" key="accepted"></TabPane>
                                                <TabPane tab="Rejected" key="rejected"></TabPane>
                                            </Tabs>
                                            {user?.type == 'supplier' ?
                                                <Table size="small" className="rfiTable" pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '20'] }} dataSource={rfi} columns={columns}></Table> :
                                                <Table size="small" className="rfiTable" pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '20'] }} loading={isLoading} style={{ width: '100%' }} dataSource={rfi} columns={columns} />}
                                        </Space>
                                    </div>
                                </Card>
                            </div> :
                        <div style={{ width: '100%' }}>
                            <div style={{ width: '80%', padding: '0 100px 10px' }}>
                                <Text style={{ fontWeight: 500, fontSize: 18 }}>Activity Center</Text>
                                <div style={{ width: '40%', justifyContent: 'flex-start', fontSize: 12 }}>
                                    <Link to="/rfq" className="link">Manage RFI</Link>
                                    <Text type="secondary"> / Vitamine B</Text>
                                </div>

                            </div>
                            <Card style={{ width: '100%' }}>
                                <div style={{ padding: '0 80px 10px' }}>
                                <div style = {{display: 'flex',flexDirection: 'column'}}>
                            <Text>Supplier: <Text type = 'secondary'>{selectedRfi?.supplier?.name}</Text></Text>
                            <Text>Product: <Text type = 'secondary'>{selectedRfi?.productRequired?.name + " " + selectedRfi?.productRequired?.strength}</Text></Text>
                        </div>
                                </div>
                                <div style={{ padding: '30px 80px 10px' }}>
                                    {activity?.map((item, index) => {
                                        console.log(item)
                                        console.log(item.addedAt)
                                        let addedDate = item?.addedAt != undefined ? item?.addedAt : '12/01/2022 12:34:35'
                                        let date = new Date(addedDate)
                                        return (
                                            <div>
                                                {item.by.toString() === user._id.toString() ? 
                                                <Avatar className="activityAvatar" size={25} style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />

                                                :
                                                <Avatar size={25} icon={<UserOutlined />}></Avatar>
                                                }
                                                
                                                <Space style={{ marginLeft: 20 }} direction='vertical'>
                                                    <Space>
                                                        <Text>{item.by.toString() === user._id.toString() ? 'Me' : 'Not Me'}</Text>
                                                        <Space>
                                                            <Text type='secondary'>{date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()}</Text>
                                                            <Text type='secondary'>{date.getHours() + ":" + date.getMinutes()}</Text>
                                                        </Space>
                                                    </Space>
                                                    <Space>
                                                        <Text>{item.description}</Text>
                                                    </Space>
                                                </Space>
                                                {index < activity.length - 1 ? <Divider /> : null}
                                            </div>
                                        )
                                    })}
                                </div>

                            </Card>
                        </div>
                }
            </Content>
        </Layout>
    )
}
export default ManageRFI